import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import './OfficeClockPresets.scss';

import Tooltip from '../General/Tooltip';
import { TIME_RANGE, slotToTimeStr } from '../../helpers/office_helpers';

/*
 * Quick-select time range pills: Morning, Afternoon, Full Day, Rest of Day, and hourly blocks.
 * Pills that overlap an existing booking show a green "booked" state with a tooltip.
 * Selecting an active preset clears the range and resets to a point-in-time.
 */
const OfficeClockPresets = ({
  quickPresets,
  hasRange,
  localStart,
  localEnd,
  presetBookingMatch,
  unmatchedBookings,
  clearRange,
  setLocalStart,
  setLocalEnd,
  setSelectedTime,
  setSelectedEndTime
}) => {
  const handlePresetClick = p => {
    const isActive = hasRange && localStart === p.start && localEnd === p.end;
    if (isActive) {
      clearRange();
    } else {
      setLocalStart(p.start);
      setLocalEnd(p.end);
      setSelectedTime(slotToTimeStr(p.start));
      setSelectedEndTime(slotToTimeStr(p.end));
    }
  };

  return (
    <div className='clock-quick-pills'>
      {quickPresets.map(p => {
        const isActive = hasRange && localStart === p.start && localEnd === p.end;
        const matchedBooking = presetBookingMatch(p);
        return (
          <Tooltip
            key={p.label}
            message={
              matchedBooking
                ? `${matchedBooking.space?.name || 'Booked'} — ${moment(matchedBooking.starts_at).format('h:mm A')} to ${moment(
                    matchedBooking.ends_at
                  ).format('h:mm A')}`
                : ''
            }
          >
            <button className={cn('quick-pill', { active: isActive, booked: !!matchedBooking && !isActive })} onClick={() => handlePresetClick(p)}>
              {p.label}
              {isActive && <span className='pill-clear'>&times;</span>}
            </button>
          </Tooltip>
        );
      })}
      {unmatchedBookings.map(b => {
        const startLabel = moment(b.starts_at).minutes() === 0 ? moment(b.starts_at).format('hA') : moment(b.starts_at).format('h:mmA');
        const endLabel = moment(b.ends_at).minutes() === 0 ? moment(b.ends_at).format('hA') : moment(b.ends_at).format('h:mmA');
        return (
          <Tooltip
            key={b.id}
            message={`${b.space?.name || 'Booked'} — ${moment(b.starts_at).format('h:mm A')} to ${moment(b.ends_at).format('h:mm A')}`}
          >
            <span className='quick-pill booked'>
              {startLabel}–{endLabel}
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default OfficeClockPresets;
